import React, { useEffect } from 'react';
import { func } from 'prop-types';

import DeviceSettingsBar from 'Elements/DeviceSettingsBar';
import Meeting from 'Elements/Meeting';
import { withMeetingContext } from 'Scenes/_root/meetingContext';
import styles from './styles.scss';

export const PatientMeeting = ({
  meetingEndAndPatientToComplete,
  registerMeetingCallbacks,
}) => {
  // only executes on load
  useEffect(() => {
    const deregisterMeetingCallbacks = registerMeetingCallbacks('patientMeeting', {
      onMeetingEnd: () => {
        // go to call completed page
        meetingEndAndPatientToComplete();
      },
    });
    // return here so that useEffect cleans up our registration
    return deregisterMeetingCallbacks;
  }, []);
  return (
    <div className={styles.patientMeetingWrapper}>
      <div className={styles.main}>
        <Meeting />
      </div>
      <DeviceSettingsBar />
    </div>
  );
};

PatientMeeting.propTypes = {
  meetingEndAndPatientToComplete: func.isRequired,
  registerMeetingCallbacks: func.isRequired,
};

export default withMeetingContext(['registerMeetingCallbacks'])(PatientMeeting);
